export const replaceJSX = function (string, find, replace) {
  if (Array.isArray(string)) {
    return string.flatMap((item) =>
      typeof item === "string" ? replaceJSX(item, find, replace) : [item]
    );
  }
  if (!string) return string;
  return string
    .split(find)
    .flatMap((item) => [item, replace])
    .slice(0, -1);
};
